module.exports = __webpack_public_path__ + "web_static/img/inspire_animation.cf43a8d7.gif";